export enum UserRole {
  ROLE_INTERNAL_USER = "ROLE_INTERNAL_USER",
  ROLE_EXTERNAL_USER = "ROLE_EXTERNAL_USER",
  ROLE_AGENCY = "ROLE_AGENCY"
}
